export const METRIC_CARDS_KEY_PREFIX = "demand.analysis.search.trends.metric.cards";
